import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { NzProgressComponent } from "ng-zorro-antd/progress";
import { Subscription } from "rxjs";

interface LoaderConfig {
  isLoading: boolean;
  type: 'full' | 'small' | 'inline';
  dismissible?: boolean;
  progress?: number;
  isIndeterminate?: boolean;
  message?: string;
}

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, NzProgressComponent],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  @Input() config: LoaderConfig = {
    isLoading: false,
    type: 'full',
    dismissible: false,
    progress: 0,
    isIndeterminate: true,
    message: 'Loading...'
  };

  private loadingSub?: Subscription;

  constructor(private loadingService: LoadingService) {}

  ngOnInit() {
    this.loadingSub = this.loadingService.loading$.subscribe((config) => {
      this.config = config;
    });
  }

  dismiss() {
    this.loadingService.hide();
  }

  ngOnDestroy() {
    this.loadingSub?.unsubscribe();
  }
}
